import { useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, TimePicker, Row, Col, Divider, Typography, Switch, message, Button, Space } from "antd";
import axios from "axios";
import moment from "moment";

export default function VerificadoresEditForm(props) {
  //Email, Nombre, Apellido, Rol, DiasAntes, DiasDespues, HoraInicio, HoraFin, Activo

  const { isModalVisible, setIsModalVisible, isEdit, setIsEdit, record, setRecord, setInspectors } = props;

  const [form] = Form.useForm();

  useEffect(() => {
    if (!record) return;

    if (!isEdit) {
      form.resetFields();
    } else {
      form.setFieldsValue({
        Email: record.Email,
        Password: record.Password,
        Nombre: record.Nombre,
        Apellido: record.Apellido,
        Rol: record.Rol,
        DiasAntes: record.DiasAntes,
        DiasDespues: record.DiasDespues,
        HoraInicio: record.HoraInicio ? moment(record.HoraInicio, "HH:mm:ss") : null,
        HoraFin: record.HoraFin ? moment(record.HoraFin, "HH:mm:ss") : null,
        Activo: record.Activo,
      });
    }
  }, [record, form, isEdit]);

  const handleOK = (values) => {
    form.validateFields().then((values) => {
      const requestData = {
        Email: values.Email,
        Nombre: values.Nombre,
        Apellido: values.Apellido,
        Rol: values.Rol,
        DiasAntes: values.DiasAntes,
        DiasDespues: values.DiasDespues,
        HoraInicio: moment(values.HoraInicio, "HH:mm:ss").format("HH:mm:ss"),
        HoraFin: moment(values.HoraFin, "HH:mm:ss").format("HH:mm:ss"),
        Activo: values.Activo,
      };

      if (values.Password) {
        requestData.Password = values.Password;
      }

      if (isEdit) {
        axios
          .patch(`${process.env.REACT_APP_API_URL}/verificadores/${record.Email}`, requestData)
          .then(() => {
            message.success("Verificador actualizado exitosamente");
            axios.get(`${process.env.REACT_APP_API_URL}/verificadores/getVerificadores`).then((response) => {
              setInspectors(response.data);
            });
            setIsModalVisible(false);
          })
          .catch(() => {
            message.error("Hubo un error al actualizar el verificador.");
          });
      } else {
        axios
          .post(`${process.env.REACT_APP_API_URL}/verificadores`, requestData)
          .then(() => {
            message.success("Verificador creado exitosamente");
            axios.get(`${process.env.REACT_APP_API_URL}/verificadores/getVerificadores`).then((response) => {
              setInspectors(response.data);
            });
            setIsModalVisible(false);
          })
          .catch(() => {
            message.error("Hubo un error al crear el verificador.");
          });
      }
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="Verificadores"
      visible={isModalVisible}
      width={720} // Makes the modal wider
      footer={null}
      onCancel={handleCancel}
    >
      <Form layout="vertical" form={form} onFinish={handleOK}>
        <Divider>
          <Typography.Text type="secondary">Información de acceso</Typography.Text>
        </Divider>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="Email" label="Email" rules={[{ required: true, message: "Ingresa el email" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Password" label="Password" rules={[{ required: isEdit ? false : true, message: "Ingresa el password" }]}>
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>

        <Divider>
          <Typography.Text type="secondary">Información personal</Typography.Text>
        </Divider>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="Nombre" label="Nombre" rules={[{ required: true, message: "Ingresa el nombre" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Apellido" label="Apellido" rules={[{ required: true, message: "Ingresa el apellido" }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Divider>
          <Typography.Text type="secondary">Permisos</Typography.Text>
        </Divider>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="Rol" label="Rol" rules={[{ required: true, message: "Ingresa el rol" }]}>
              <Select>
                <Select.Option value="administrador">Administrador</Select.Option>
                <Select.Option value="verificador">Verificador</Select.Option>
                <Select.Option value="director">Director</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Activo" label="Activo" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="DiasAntes" label="Rango de Días" rules={[{ required: true, message: "Ingresa los días antes" }]}>
              <InputNumber placeholder="Días Antes de fecha actual" min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="DiasDespues" label=" " rules={[{ required: true, message: "Ingresa los días después" }]}>
              <InputNumber placeholder="Días Después de fecha actual" min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item name="HoraInicio" label="Rango de Horario" rules={[{ required: true, message: "Selecciona un rango de horario" }]}>
              <TimePicker format="HH:mm" minuteStep={5} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="HoraFin" label=" " rules={[{ required: true, message: "Selecciona un rango de horario" }]}>
              <TimePicker format="HH:mm" minuteStep={5} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Space>
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>
          <Button onClick={handleCancel}>Cancelar</Button>
        </Space>
      </Form>
    </Modal>
  );
}
